import React, { useEffect, useState } from "react";
import ApexChart from "../../ExtraComponents/ApexChart";
import { useDispatch, } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getDashboardData } from "../../ReduxStore/Slice/Dashboard/dashboardSlice";
import { deleteQuote, convertQuote, createQuote } from "../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { deleteContract, createContract, downloadContract } from "../../ReduxStore/Slice/Contract/contractSlice";
import { getRecentActivityData } from "../../Service/Dashboard/dashboardService";
import Datatable from "../../ExtraComponents/ReusableTable2";
import ReusableModal from "../../ExtraComponents/ReusableModal";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs";
import { Pencil, Trash2, Eye } from "lucide-react";
import { DatePicker, Space, theme } from "antd";
import { clamp } from "@mui/utils";
import { DateConvert, DateConvertWithTime, cleanHtmlEntities ,roundNumber } from '../../Utils/CommonFun';
import Swal from "sweetalert2";
import axios from "axios";
import ReactPaginate from "react-paginate";


const Dashboard = () => {
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const [activeTab, setActiveTab] = useState("current-month");
  const [dashboard, setDashboard] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  // const agent_id = localStorage.getItem("agent_id");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const [range, setRange] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [modalLabel, setModalLabel] = useState("");
  const [modalList, setModalList] = useState([]);




  // console.log("Dashboard Data:", dashboard);


  ////////////////////// Start List Qoute and Contract  Data //////////////////

  const [recentActivityData, setRecentActivityData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [InputValue, setInputValue] = useState('');

  const [debouncedSearch, setDebouncedSearch] = useState("");



  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(InputValue);
    }, 500); // 500ms delay, adjust as needed
    return () => clearTimeout(timer); // 
  }, [InputValue]);

 
  useEffect(() => {
    setCurrentPage(1);
    getRecentActivity();
  }, [debouncedSearch]);




  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };



  useEffect(() => {
    getRecentActivity();
  }, [currentPage, pageSize, activeTab, range]);

  const getRecentActivity = async () => {
    let req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue, filter: activeTab };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    try {
      const response = await getRecentActivityData(req);
      if (response.status) {
        setRecentActivityData(response.data);
        setTotalRecords(response?.pagination?.total)

      } else {
        setRecentActivityData([]);
      }
    } catch (error) {
      console.error("Error fetching charge basis data:", error);
    }


    // await dispatch(getRecentActivityData(req))
    //   .unwrap()
    //   .then((response) => {
    //     if (response.status) {
    //       setRecentActivityData(response.data);
    //       setTotalRecords(response?.pagination?.total)

    //     } else {
    //       setRecentActivityData([]);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching charge basis data:", error);
    //   });
  };


  ////////////////////// End  List Qoute and Contract  Data ///////////////////

  const getCreatedLabel = (date) => {
    const diff = Math.floor(
      (new Date().setHours(0, 0, 0, 0) - new Date(date).setHours(0, 0, 0, 0))
      / 86400000
    );

    return diff === 0
      ? "Created today"
      : diff === 1
        ? "Created yesterday"
        : `Created ${diff} days ago`;
  };


  // const contractCreated_amount = Number(
  //   dashboard?.contractCreated_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const contractCreated_amount = roundNumber(dashboard?.contractCreated_list?.row_total)

  // const contractsSent_amount = Number(
  //   dashboard?.contractsSent_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const contractsSent_amount = roundNumber(dashboard?.contractsSent_list?.row_total)

  // const unsentContracts_amount = Number(
  //   dashboard?.unsentContracts_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const unsentContracts_amount = roundNumber(dashboard?.unsentContracts_list?.row_total)

  // const contractsSigned_amount = Number(
  //   dashboard?.contractsSigned_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const contractsSigned_amount = roundNumber(dashboard?.contractsSigned_list?.row_total)

  // const awaitingSignature_amount = Number(
  //   dashboard?.awaitingSignature_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const awaitingSignature_amount = roundNumber(dashboard?.awaitingSignature_list?.row_total)


  // const quote_created_amount = Number(
  //   dashboard?.quote_created_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const quote_created_amount = roundNumber(dashboard?.quote_created_list?.row_total)

  // const quote_sent_amount = Number(
  //   dashboard?.quote_sent_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const quote_sent_amount = roundNumber(dashboard?.quote_sent_list?.row_total)

  // const quote_unsent_amount = Number(
  //   dashboard?.quote_unsent_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );

  const quote_unsent_amount = roundNumber(dashboard?.quote_unsent_list?.row_total)


  // const quote_reviewed_amount = Number(
  //   dashboard?.quote_reviewed_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );
  const quote_reviewed_amount = roundNumber(dashboard?.quote_reviewed_list?.row_total)


  // const quote_accepted_amount = Number(
  //   dashboard?.quote_accepted_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );

  const quote_accepted_amount = roundNumber(dashboard?.quote_accepted_list?.row_total)

  // const quote_rejected_amount = Number(
  //   dashboard?.quote_rejected_list?.reduce((s, i) => s + (+i?.row_total || 0), 0).toFixed(2)
  // );

  const quote_rejected_amount = roundNumber(dashboard?.quote_rejected_list?.row_total)





  const handleCloseModal = () => {
    setModalLabel("");
    setModalList([]);
    setshowModal(false);

  };

  const StatusPill = ({ status }) => {
    const map = {
      'Quote Accepted': "bg-green-light text-green",
      'Contract Signed': "bg-green-light text-green",

      'Quote Rejected': "bg-green-light text-red",

      'In Progress': "bg-yellow-light text-yellow",
      'Contract Reviewed': "bg-yellow-light text-yellow",

      'Quote Sent': "bg-pink-light text-pink",
      'Contract Sent': "bg-pink-light text-gray",

      'Requested Higher Discount': "bg-wine-light text-wine",
      'Discount Approved': "bg-green-light text-green",

      'Discount Rejected': "bg-red-light text-red",
    };


    return (
      <span
        style={{
          fontSize: "13px",
          fontWeight: "500",
        }}
        className={`px-3 pb-1 rounded-pill font-weight-medium ${map[status]}`}
      >
        {status}
      </span>
    );
  };

  const handleEdit = (type, row) => {

    if (type === "Quote") {
      nevigate("/admin/quote/create-quote", { state: { row: row } });
    } else if (type === "Contract") {
      nevigate("/admin/contracts/create-contract", { state: { row: row } });
    } else {
      return;
    }
  };

  const handleDelete = (type, row) => {
    if (type === "Quote") {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this quote!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const req = { row: row };
          await dispatch(deleteQuote(req)).unwrap()
            .then((response) => {
              if (response.status) {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'Your quote has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1500
                });
                DashboardData();
              } else {
                Swal.fire('Error!', 'Something went wrong.', 'error');
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Your quote is safe :)', 'error')
        }
      });

    }
    else if (type === "Contract") {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this contract!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const req = { id: row.id };
          await dispatch(deleteContract(req))
            .unwrap()
            .then((response) => {
              if (response.status) {
                Swal.fire({
                  title: "Deleted!",
                  text: "Your Contract has been deleted.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 3000,
                });
                DashboardData();
              } else {
                Swal.fire("Error!", "Something went wrong.", "error");
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "Your quote is safe :)", "error");
        }
      });
    }
    else {
      return;
    }
  }

  const handleStopReminder = async (type, row) => {

    if (type === "Quote") {
      let stop_remainder_status = row.stop_remainder_status;
      let msg = "Stop";
      if (Number(row.stop_remainder_status) == 1) {
        stop_remainder_status = '0';
        msg = "Start";
      } else {
        stop_remainder_status = '1';
        msg = "Stop";
      }

      Swal.fire({
        title: "Are you sure?",
        text: `You want to ${msg} reminder for this contract!`,
        icon: "warning",
        showCancelButton: true,

        confirmButtonText: msg + " Reminder",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

          console.log("req", req);
          await dispatch(createQuote(req))
            .unwrap()
            .then((response) => {
              if (response.status) {
                Swal.fire({
                  title: "Success!",
                  text: `Reminder ${msg} successfully.`,
                  showConfirmButton: true,
                  confirmButtonText: "Ok",
                  icon: "success",

                  timer: 3000,
                });
                DashboardData();
              } else {
                Swal.fire("Error!", "Something went wrong.", "error");
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });
    }
    else if (type === "Contract") {
      let stop_remainder_status = row.stop_remainder_status;
      let msg = "Stop";
      if (Number(row.stop_remainder_status) == 1) {
        stop_remainder_status = '0';
        msg = "Start";
      } else {
        stop_remainder_status = '1';
        msg = "Stop";
      }

      Swal.fire({
        title: "Are you sure?",
        text: `You want to ${msg} reminder for this contract!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: msg + " Reminder",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

          console.log("req", req);
          await dispatch(createContract(req))
            .unwrap()
            .then((response) => {
              if (response.status) {
                Swal.fire({
                  title: "Success!",
                  text: `Reminder ${msg} successfully.`,

                  icon: "success",
                  showConfirmButton: true,
                  confirmButtonText: "OK",
                  timer: 3000,
                });
                DashboardData();
              } else {
                Swal.fire("Error!", "Something went wrong.", "error");
              }
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });
    } else {
      return;
    }

  }


  // Quote Function
  const handleConvert = async (e, row) => {

    let req = { row: row };
    await dispatch(convertQuote(req)).unwrap()
      .then((res) => {
        if (res.status) {

          sessionStorage.setItem("contract_id", res.contract_id);
          nevigate("/admin/contracts/create-contract", { state: { row: { id: res.contract_id, step: 3 } } });
        }
        else {

        }
      })
      .catch((err) => {

      });


  };

  // Contract Function
  const handleDocumentDownload = async (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    let req = { agent_id: agent_id, id: row?.id };
    await dispatch(downloadContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          // console.log("response.data-->>",response)
          let access_token = response.data
          setIsLoading(true);
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
            headers: {
              //Authorization: "Bearer " + row?.access_token,
              Authorization: "Bearer " + access_token,
            },
            responseType: "blob", // Important for binary PDF
          };

          axios
            .request(config)
            .then((response) => {
              setIsLoading(false);
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${row.subject || "document"}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              setIsLoading(false);

              console.log("Download error:", error);
            });


        } else {
          setIsLoading(false);

        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching charge basis data:", error);
      });
  };

  const handleResendContract = async (row) => {

    if (row.resend_contract_exist_data != null) {
      // Confirmation dialog
      Swal.fire({
        title: "Are you sure?",
        html: `<div>
               <div>Contract is already sent!</div>
               <div>Do you want to resend this contract?</div>
             </div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Resend",
        cancelButtonText: "Cancel"
      }).then(async (result) => {
        if (result.isConfirmed) {

          let exist_send_data = JSON.parse(row.resend_contract_exist_data);

          const req = {
            id: Number(exist_send_data.id),
            step: 4,
            mail_to: exist_send_data.mail_to,
            subject: exist_send_data.subject,
            template_id: exist_send_data.template_id,
            clientid: exist_send_data.clientid,
            ContractOwner: userDetails.id,
            agent_id: exist_send_data.agent_id,
            director_letter: exist_send_data.director_letter,
            self_assessment: exist_send_data.self_assessment,
            payment_type: exist_send_data.payment_type,
            cc_to: exist_send_data.cc_to || "",
            bcc_to: exist_send_data.bcc_to || "",
            email_template_details: exist_send_data.email_template_details

          }

          setIsLoading(true);
          await dispatch(createContract(req)).unwrap()
            .then((res) => {
              if (res.status) {

                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: res.message,
                  timer: 3000,
                  timerProgressBar: true,
                });
                setIsLoading(false);
                DashboardData();
                return;
              }
              else {
                setIsLoading(false);
                if (res.message.includes("_____________")) {

                  Swal.fire({
                    icon: "warning",
                    title: "Warning..",
                    text: "Signature Tag Is Missing In The Document.",
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  return;
                } else {

                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res.message,
                    timer: 3000,
                    timerProgressBar: true,
                  })
                  return;
                }

              }
            }).catch((err) => {

              setIsLoading(false);
              console.log("err", err);
            })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });

    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "this contract is not sent yet",
        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
        timer: 3000,
      });
      return;
    }

  }





  const columns = [
    // {
    //   name: "SUBJECT",

    //   cell: (row) => (
    //     <span style={{ fontWeight: "500" }} className="text-dark">
    //       {row.subject}
    //     </span>
    //   ),
    //   selector: (row) => row.subject,
    //   sortable: true,
    // },
    {
      name: "SUBJECT",
      selector: row => row.subject ?? "",
      sortable: true,
      sortFunction: (a, b) =>
        (a.subject || "").localeCompare(b.subject || "", undefined, {
          sensitivity: "base",
        }),
      cell: row => (
        <span className="text-dark" style={{ fontWeight: 500 }}>
          {row.subject}
        </span>
      ),
    },
    {
      name: "CLIENT",
      selector: (row) => cleanHtmlEntities(row.client),
      className: "text-muted",
      sortable: true,
      sortFunction: (a, b) => a.client.localeCompare(b.client),
    },
    {
      name: "CREATED ON",
      selector: row => row.createdAt,
      cell: row => DateConvertWithTime(row.createdAt),
      sortable: true,
      sortFunction: (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      name: "TYPE",
      cell: (row) => (
        <span
          style={{
            fontSize: "13px",
            fontWeight: "500",
          }}
          className="px-3 pt-1 pb-2 border rounded-pill text-dark "
        >
          {row.type}
        </span>
      ),
      sortable: true,
      sortFunction: (a, b) => a.type.localeCompare(b.type),
    },
    {
      name: "STATUS",
      cell: (row) => <StatusPill status={row.status_name} />,
      sortable: true,
      sortFunction: (a, b) => a.status_name.localeCompare(b.status_name),
    },
    {
      name: "ACTION", width: "230px;",
      selector: (row) => (
        row.type === "Quote" ?
          <>
            <div className="d-flex w-100 text-end">

              <button className="btn fs-4 py-0 px-1" onClick={() => handleEdit(row.type, row)}>
                <i className=" ri-edit-line" />
              </button>
              <button className="btn fs-4 py-0 px-1" onClick={() => handleDelete(row.type, row)}>
                <i className="bx bx-trash" />
              </button>
              {/* Resend Contract Button with appropriate icon */}
              {Number(row?.status) !== 0 ?
                <>
                  <button
                    className="btn fs-4 py-0 px-1"
                    onClick={() => handleStopReminder(row.type, row)}
                    title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
                  >
                    {/* <i className="ri-timer-line" /> */}
                    <i
                      className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                        }`}
                    />
                  </button>
                </> :
                ""
              }
              {Number(row.status) != 0 && row?.Contracts?.length === 0
                ?
                <button className="btn btn-sm-pink" onClick={(e) => handleConvert(e, row)}>
                  <i className=" ri-repeat-line pe-1" />
                  Convert
                </button>
                : "  "
              }
            </div>


          </>
          :
          row.type === "Contract" ?
            <>
              <div>
                {/* Edit Button (hidden if step is 4) */}
                {Number(row?.step) === 4 ? (
                  ""
                ) : (
                  <button
                    className="btn fs-4 py-0 px-1"
                    onClick={() => handleEdit(row.type, row)}
                    title="Edit"
                  >
                    <i className="ri-edit-line" />
                  </button>
                )}

                {/* Delete Button */}
                <button
                  className="btn fs-4 py-0 px-1"
                  onClick={() => handleDelete(row.type, row)}
                  title="Delete"
                >
                  <i className="bx bx-trash" />
                </button>

                {/* Download/Convert Button */}
                <button
                  className="btn fs-4 py-0 px-1"
                  onClick={() => handleDocumentDownload(row)}
                  title="Download Document"
                >
                  <i className="ri-download-2-line" />
                </button>

                {/* Resend Contract Button with appropriate icon */}
                {Number(row?.step) !== 4 ?
                  "" :
                  <>
                    <button
                      className="btn fs-4 py-0 px-1"
                      onClick={(e) => handleResendContract(row)}
                      title="Resend Contract"
                    >
                      <i className="ri-send-plane-line" />
                    </button>



                    <button
                      className="btn fs-4 py-0 px-1"
                      onClick={() => handleStopReminder(row.type, row)}
                      title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
                    >
                      {/* <i className="ri-timer-line" /> */}
                      <i
                        className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                          }`}
                      />
                    </button>

                  </>
                }
              </div>
            </>
            : ""



        // <div className="flex gap-3 text-pink-500">
        //   <Pencil onClick={() => handleEdit(row.type, row)} size={16} className="cursor-pointer" />
        //   <Trash2 size={16} className="cursor-pointer" />
        //   <Eye size={16} className="cursor-pointer" />
        // </div>

      ),
    },
  ];

  const DashboardData = async () => {

    setIsLoading(true);
    let req = { agent_id: agent_id, filter: activeTab, link: "dashboard" };
    if (
      activeTab === "custom-date" &&
      Array.isArray(range) &&
      range[0] &&
      range[1]
    ) {
      req = {
        agent_id: agent_id,
        filter: activeTab,
        link: "dashboard",
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD"),
      };
    }
    await dispatch(getDashboardData(req))
      .unwrap()
      .then((response) => {
        setIsLoading(false);
        if (response.status) {
          setDashboard(response.data);
        } else {
          setDashboard([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    DashboardData();
  }, [activeTab, range, agent_id]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };

  // const seriesData = [10, 50, 30, 40, 70, 90, 120, 150, 200,170,150,125];
  const seriesData = [10, 50, 30, 40, 70, 90, 120];

  // const categories = ["1", "15", "30"];

  // const categories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug","Sep","Oct","Nov","Dec"];
  const categories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"];


  const funShowModal = (label, list, type) => {
    if (type === "quote") {
      nevigate("/admin/quote/quotes-dashboard");
      return
    } else if (type === "contract") {
      nevigate("/admin/contracts/contracts-dashboard");
      return
    } else {
      return;
    }

    return;
    setModalLabel(label);
    setModalList(list);
    setshowModal(true);
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
        // timer: 8000,
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const showPagination = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

  return (
    <>
      <div className="container ">
        {/* Header */}
        <div className="row align-items-top">
          <div className="col-md-9">
            <div className="mb-4">
              <h3 className="fw-bold mb-0">360° Dashboard</h3>
              <p className="text-muted">
                Complete overview of Quotes and Contracts
              </p>
            </div>
          </div>
          <div className="col-md-3">

            <div className=" d-flex header-select align-items-center">

              <select
                onChange={handleTabChange}
                value={activeTab}
                className="form-select"
              >
                <option value="current-month">Current Month</option>
                <option value="prev-month">Previous Month</option>
                <option value="current-quarter">Current Quarter</option>
                <option value="previous-quarter">Previous Quarter</option>
                <option value="current-calender-quarter">
                  Current Calendar Year
                </option>
                <option value="prev-calender-year">Previous Calendar Year</option>
                <option value="custom-date">Custom Date</option>
              </select>
              {/* <button className="btn btn-pink  w-50 ms-3"><i className="ri-add-line"></i>Add New</button> */}
            </div>

            {activeTab === "custom-date" && (
              <div className=" d-flex gap-2 mt-2 mb-3">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateRangePicker"]}>
                    <DatePicker.RangePicker
                      value={range}
                      onChange={setRange}
                      placeholder={["Start Date", "End Date"]}
                      format="DD/MM/YYYY"
                      className=""
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            )}

          </div>
        </div>


        {/* Quotes Overview */}


        {/* Contracts Overview */}
        {/* <h6 className="section-title mb-3">Contracts Overview</h6>
        <div className="row g-3 mb-4">
          <div className="col-md-12">
            <div className="row g-3">
              <div className="col-md-3">
                <div className="stat-card border" onClick={() => funShowModal("Contracts Sent", dashboard?.contractsSent_list || [] , "contract")}>
                  <div className="stat-title justify-content-between">
                    <p>Contracts Sent</p>
                    <span className="arrow">
                      <i className="ri-arrow-right-s-line "></i>
                    </span>
                  </div>
                  <h2>{dashboard?.contractsSent || 0}</h2>
                  <h5 className="text-dark">£{contractsSent_amount || 0}</h5>

                  <small className="text-muted">
                    Last month: {dashboard?.contractsSent_last || 0}

                  
                    <span className={dashboard?.contractsSent > dashboard?.contractsSent_last ? "text-success" : "text-danger"}>
                      {dashboard?.contractsSent > dashboard?.contractsSent_last ? "↑" : "↓"}
                      {
                        dashboard?.contractsSent_last &&
                          dashboard?.contractsSent_last !== 0
                          ? (
                            ((dashboard?.contractsSent -
                              dashboard?.contractsSent_last) /
                              dashboard?.contractsSent_last) *
                            100
                          ).toFixed(2)
                          : 0
                      }%</span>

                  </small>
                </div>

              </div>

              <div className="col-md-3">
                <div className="stat-card border" onClick={() => funShowModal("Contracts Signed", dashboard?.contractsSigned_list || [] , "contract")}>
                  <div className="stat-title justify-content-between">
                    <p> Contracts Signed</p>
                    <span className="arrow">
                      <i className="ri-arrow-right-s-line "></i>
                    </span>
                  </div>
                  <h2>{dashboard?.contractsSigned || 0}</h2>
                  <h5 className="text-dark">£{contractsSigned_amount || 0}</h5>

                  <small className="text-muted">
                    Last month: {dashboard?.contractsSigned_last || 0}
                    <span className={dashboard?.contractsSigned > dashboard?.contractsSigned_last ? "text-success" : "text-danger"}>
                      {dashboard?.contractsSigned > dashboard?.contractsSigned_last ? "↑" : "↓"}
                      {
                        dashboard?.contractsSigned_last &&
                          dashboard?.contractsSigned_last !== 0
                          ? (
                            ((dashboard?.contractsSigned -
                              dashboard?.contractsSigned_last) /
                              dashboard?.contractsSigned_last) *
                            100
                          ).toFixed(2)
                          : 0
                      }%</span>
                  </small>
                </div>
              </div>
              <div className="col-md-3">
                <div className="stat-card border" onClick={() => funShowModal("Awaiting Signature", dashboard?.awaitingSignature_list || [] , "contract")}>
                  <div className="stat-title justify-content-between">
                    <p>Awaiting Signature</p>
                    <span className="arrow">
                      <i className="ri-arrow-right-s-line "></i>
                    </span>
                  </div>
                  <h2>{dashboard?.awaitingSignature || 0}</h2>
                  <h5 className="text-dark">£{awaitingSignature_amount || 0}</h5>

                  <small className="text-muted">
                    Last month: {dashboard?.awaitingSignature_last || 0} <span className={dashboard?.awaitingSignature > dashboard?.awaitingSignature_last ? "text-success" : "text-danger"}>
                      {dashboard?.awaitingSignature > dashboard?.awaitingSignature_last ? "↑" : "↓"}
                      {
                        dashboard?.awaitingSignature_last &&
                          dashboard?.awaitingSignature_last !== 0
                          ? (
                            ((dashboard?.awaitingSignature -
                              dashboard?.awaitingSignature_last) /
                              dashboard?.awaitingSignature_last) *
                            100
                          ).toFixed(2)
                          : 0
                      }%</span>
                  </small>
                </div>
              </div>

              <div className="col-md-3">
                <div className="stat-card border" onClick={() => funShowModal("Unsent Contracts", dashboard?.unsentContracts_list || [] , "contract")}>
                  <div className="stat-title justify-content-between">
                    <p>Unsent Contracts</p>
                    <span className="arrow">
                      <i className="ri-arrow-right-s-line "></i>
                    </span>
                  </div>
                  <h2>{dashboard?.unsentContracts || 0}</h2>
                  <h5 className="text-dark">£{unsentContracts_amount || 0}</h5>

                  <small className="text-muted">
                    Last month: {dashboard?.unsentContracts_last || 0} <span className={dashboard?.unsentContracts > dashboard?.unsentContracts_last ? "text-success" : "text-danger"}>
                      {dashboard?.unsentContracts > dashboard?.unsentContracts_last ? "↑" : "↓"}
                      {
                        dashboard?.unsentContracts_last &&
                          dashboard?.unsentContracts_last !== 0
                          ? (
                            ((dashboard?.unsentContracts -
                              dashboard?.unsentContracts_last) /
                              dashboard?.unsentContracts_last) *
                            100
                          ).toFixed(2)
                          : 0
                      }%</span>
                  </small>
                </div>
              </div>
            </div>
          </div>

        </div> */}



        <h6 className="section-title mb-3">Quotes Overview</h6>
        <div className="row row-cols-lg-5 row-cols-md-3 row-cols-2 g-3 mb-4">
          {[
            { label: "Quotes Created", value: dashboard?.quote_created || 0, price: `£${quote_created_amount || 0}`, list: dashboard?.quote_created_list || [] },
            { label: "Quotes Unsent", value: dashboard?.quote_unsent || 0, price: `£${quote_unsent_amount || 0}`, list: dashboard?.quote_sent_list || [] },
            { label: "Quotes Sent", value: dashboard?.quote_sent || 0, price: `£${quote_sent_amount || 0}`, list: dashboard?.quote_sent_list || [] },

            // { label: "Quotes in Review", value: dashboard?.quote_reviewed || 0, price: `£${quote_reviewed_amount || 0}`, list: dashboard?.quote_reviewed_list || [] },
            { label: "Quotes Accepted", value: dashboard?.quote_accepted || 0, price: `£${quote_accepted_amount || 0}`, list: dashboard?.quote_accepted_list || [] },
            { label: "Quotes Rejected", value: dashboard?.quote_rejected || 0, price: `£${quote_rejected_amount || 0}`, list: dashboard?.quote_rejected_list || [] },
          ].map((item, i) => (
            <div className="col " key={i}>
              <div className="stat-card border" onClick={() => funShowModal(item?.label, item?.list, "quote")}>
                <div className="stat-title">
                  {item.label}
                  <span className="arrow">
                    <i className="ri-arrow-right-s-line "></i>
                  </span>
                </div>

                <div className="stat-value">{item.value}</div>
                <h5 className="text-dark">{item.price}</h5>
              </div>
            </div>
          ))}
        </div>



        <h6 className="section-title mb-3">Contracts Overview</h6>
        <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2 g-3 mb-4">
          {[
            { label: "Contracts Created", value: dashboard?.contractCreated || 0, price: `£${contractCreated_amount || 0}`, list: dashboard?.contractCreated_list || [] },
            { label: "Contract Unsent", value: dashboard?.unsentContracts || 0, price: `£${unsentContracts_amount || 0}`, list: dashboard?.unsentContracts_list || [] },
            { label: "Pending for Signature", value: dashboard?.contractsSent || 0, price: `£${contractsSent_amount || 0}`, list: dashboard?.contractsSent_list || [] },

            // { label: "Contracts in Review", value: dashboard?.quote_reviewed || 0, price: `£${quote_reviewed_amount || 0}`, list: dashboard?.quote_reviewed_list || [] },
            // { label: "Awaiting Signature", value: dashboard?.awaitingSignature || 0, price: `£${awaitingSignature_amount || 0}`, list: dashboard?.awaitingSignature_list || [] },
            { label: "Contracts Signed", value: dashboard?.contractsSigned || 0, price: `£${contractsSigned_amount || 0}`, list: dashboard?.contractsSigned_list || [] },
          ].map((item, i) => (
            <div className="col " key={i}>
              <div className="stat-card border" onClick={() => funShowModal(item?.label, item?.list, "contract")}>
                <div className="stat-title">
                  {item.label}
                  <span className="arrow">
                    <i className="ri-arrow-right-s-line "></i>
                  </span>
                </div>

                <div className="stat-value">{item.value}</div>
                <h5 className="text-dark">{item.price}</h5>
              </div>
            </div>
          ))}
        </div>


        {/* <h6 className="section-title mb-3">Appex Overview</h6> */}

        {/* <div className="row">
          <div className="col-md-12 mb-4">
            <div className="stat-card  border h-100">
              <div className="d-flex justify-content-between">
                <div>
                  <p>Signed Value</p>
                  
                  <span className={dashboard?.contractsSigned > dashboard?.contractsSigned_last ? "text-success" : "text-danger"}>
                    {dashboard?.contractsSigned > dashboard?.contractsSigned_last ? "↑" : "↓"}
                    {
                      dashboard?.contractsSigned_last &&
                        dashboard?.contractsSigned_last !== 0
                        ? (
                          ((dashboard?.contractsSigned -
                            dashboard?.contractsSigned_last) /
                            dashboard?.contractsSigned_last) *
                          100
                        ).toFixed(2)
                        : 0
                    }%</span>
                </div>

                <div>
                  <h2>£{dashboard?.signedValue || 0}</h2>
                  <small className="text-muted">Last month: £{dashboard?.signedValue_last || 0}</small>
                </div>
              </div>
              <ApexChart seriesData={seriesData} categories={categories} />
            </div>
          </div>

        </div> */}


        <div className="card shadow-none border rounded">
          <div className="card-header py-4 d-flex justify-content-between">
            <h5 className="card-title text-pink">Recent Activity</h5>

            <data className=" datatable-search">
              <input
                type="text"
                className="search p-2 icon"
                placeholder="Search here"
                value={InputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </data>
          </div>
          <div className="card-body px-0">
            <Datatable
              data={recentActivityData || []}
              // data={data}
              columns={columns}
              highlightOnHover
              striped
              responsive
            />

            {
              recentActivityData && recentActivityData?.length > 0 ?
                <>
                  {
                    showPagination > 1 && (
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                      />
                    )
                  }


                  <div className="mt-0">
                    <select
                      // className="perpage-select" 
                      className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                      value={pageSize}
                      onChange={handlePageSizeChange}>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={0}>{"ALL"}</option>
                    </select>
                  </div>
                </>
                :
                null
            }
          </div>
        </div>
      </div>



      {/* <div className="filter-select mb-3 select_tab">
        <div className=" d-flex">
          <select
            onChange={handleTabChange}
            value={activeTab}
            className="form-select"
          >
            <option value="current-month">Current Month</option>
            <option value="prev-month">Previous Month</option>
            <option value="current-quarter">Current Quarter</option>
            <option value="previous-quarter">Previous Quarter</option>
            <option value="current-calender-quarter">
              Current Calendar Year
            </option>
            <option value="prev-calender-year">Previous Calendar Year</option>
            <option value="custom-date">Custom Date</option>
          </select>
        </div>

        {activeTab === "custom-date" && (
          <div className=" d-flex gap-2 mt-2 mb-3">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DateRangePicker"]}>
                <DatePicker.RangePicker
                  value={range}
                  onChange={setRange}
                  placeholder={["Start Date", "End Date"]}
                  format="DD/MM/YYYY"
                  className=""
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
        )}
      </div>

      <div id="my_content">
        <div className="col-md-12">
          <div>
            <section className="section dashboard">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row">
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Contracts sent</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.contractsSent || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.contractsSent_last || 0}
                                </span>
                              )}
                            </div>
                            <div>
                              {activeTab != "custom-date" && (
                                <div className="small">
                                  <i
                                    className={`fs-5 me-1 ${dashboard?.contractsSent >
                                        dashboard?.contractsSent_last
                                        ? "ri-arrow-up-circle-fill text-success"
                                        : dashboard?.contractsSent <
                                          dashboard?.contractsSent_last
                                          ? "ri-arrow-down-circle-fill text-danger"
                                          : "text-secondary"
                                      }`}
                                  ></i>
                                  {dashboard?.contractsSent_last &&
                                    dashboard?.contractsSent_last !== 0
                                    ? (
                                      ((dashboard?.contractsSent -
                                        dashboard?.contractsSent_last) /
                                        dashboard?.contractsSent_last) *
                                      100
                                    ).toFixed(2)
                                    : 0}
                                  %
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Contracts signed</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.contractsSigned || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.contractsSigned_last || 0}
                                </span>
                              )}
                            </div>
                            <div>
                              {activeTab != "custom-date" && (
                                <div className="small">
                                  <i
                                    className={`fs-5 me-1 ${dashboard?.contractsSigned >
                                        dashboard?.contractsSigned_last
                                        ? "ri-arrow-up-circle-fill text-success"
                                        : dashboard?.contractsSigned <
                                          dashboard?.contractsSigned_last
                                          ? "ri-arrow-down-circle-fill text-danger"
                                          : "text-secondary"
                                      }`}
                                  ></i>
                                  {dashboard?.contractsSigned_last &&
                                    dashboard?.contractsSigned_last !== 0
                                    ? (
                                      ((dashboard?.contractsSigned -
                                        dashboard?.contractsSigned_last) /
                                        dashboard?.contractsSigned_last) *
                                      100
                                    ).toFixed(2)
                                    : 0}
                                  %
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Awaiting signature</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.awaitingSignature || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.awaitingSignature_last || 0}
                                </span>
                              )}
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-md-6">
                      <div className="card info-card sales-card">
                        <div className="card-body">
                          <h5 className="card-title">Unsent contracts</h5>
                          <div className="d-flex align-items-end justify-content-between ">
                            <div className="">
                              <h6>{dashboard?.unsentContracts || 0}</h6>
                              {activeTab != "custom-date" && (
                                <span className="filter-text">
                                  Last month:{" "}
                                  {dashboard?.unsentContracts_last || 0}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="card info-card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <h5 className="card-title">
                          Signed Value
                          {activeTab != "custom-date" && (
                            <div className=" small  ">
                              <i class="ri-arrow-up-circle-fill text-success fs-5 me-1"></i>
                              {dashboard?.signedValue_last &&
                                parseFloat(dashboard?.signedValue_last) !== 0
                                ? (
                                  ((parseFloat(dashboard?.signedValue) -
                                    parseFloat(dashboard?.signedValue_last)) /
                                    parseFloat(dashboard?.signedValue_last)) *
                                  100
                                ).toFixed(2)
                                : "0"}{" "}
                              %
                            </div>
                          )}
                        </h5>
                        <div className="pt-3">
                          <h6>£{dashboard?.signedValue}</h6>

                          {activeTab != "custom-date" && (
                            <span className="filter-text">
                              Last month: £
                              {dashboard?.signedValue_last || 0}{" "}
                            </span>
                          )}
                        </div>
                      </div>
                      <ApexChart
                        seriesData={seriesData}
                        categories={categories}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div> */}

      <ReusableModal
        show={showModal}
        onClose={handleCloseModal}
        title={
          <div>
            <h5 className="mb-1 fw-semibold">{modalLabel}</h5>
            <p className="text-muted small mb-0">
              Click on an item to view full details
            </p>
          </div>
        }
        body={
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            {
              modalList.length === 0 ? (
                <div className="text-center py-5">
                  <i className="bi bi-inbox fs-1 text-muted"></i>
                  <h5 className="mt-2">No data found</h5>
                </div>
              ) : (
                modalList.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center p-3 mb-3 rounded border hover-card"

                  >
                    <div>
                      <div className="fw-semibold">
                        {item?.Client.client_name}
                        {/* <i className="bi bi-box-arrow-up-right ms-2 text-muted"></i> */}
                      </div>
                      <div className="text-muted small">
                        {getCreatedLabel(item?.createdAt)}
                      </div>
                    </div>
                    <div className="fw-semibold" style={{ color: "#E6007E" }}>
                      {item?.row_total ? `£${Number(item?.row_total)}` : "£0.00"}
                    </div>
                  </div>
                ))
              )
            }
            {/* <div
              className="d-flex justify-content-between align-items-center p-3 mb-3 rounded border hover-card"
            >
              <div>
                <div className="fw-semibold">
                  Acme Corp - Annual Audit
                  <i className="bi bi-box-arrow-up-right ms-2 text-muted"></i>
                </div>
                <div className="text-muted small">
                  Created today
                </div>
              </div>

              <div className="fw-semibold" style={{ color: "#E6007E" }}>
                £85,000
              </div>
            </div> */}

            {/* <div
              className="d-flex justify-content-between align-items-center p-3 mb-3 rounded border hover-card"
              style={{ cursor: "pointer" }}
            >
              <div>
                <div className="fw-semibold">
                  Tech Solutions Ltd - Tax Advisory
                  <i className="bi bi-box-arrow-up-right ms-2 text-muted"></i>
                </div>
                <div className="text-muted small">
                  Created yesterday
                </div>
              </div>

              <div className="fw-semibold text-pink">
                £65,000
              </div>
            </div> */}

          </div>
        }
      />


    </>


  );
};

export default Dashboard;
